import { formatEmploymentType, formatFullName } from 'shared/utils/formatting';
import { PaginatedCollection } from '@types';
import { InboxTableColumnDefinition } from './inbox-table.types';
import { getShiftDateProperties } from '../../../../shared/utils/get-shift-date-properties';
import { ClaimPendingExtended } from '../../../../shared/types/checkouts.types';

export const getInboxTableData = (data: PaginatedCollection<ClaimPendingExtended>) => {
  const result: InboxTableColumnDefinition[] = data.items.map((item) => {
    const shiftDateProperties = getShiftDateProperties(item);
    const placementEmploymentType =
      item.placementEmploymentType === '' ? null : item.placementEmploymentType;
    return {
      id: item.id,
      worker: {
        fullName: formatFullName(item.worker),
        partnerName: item.worker.partnerName,
        employmentType: item.worker.employmentType,
      },
      rating: {
        id: item.rating?.id,
        value: !!item.rating?.value,
      },
      job: {
        name: item.shift.name,
        location: item.shift.location,
      },
      department: item.department,
      branchOffice: item.branchOffice,
      date: {
        scheduledStartDate: item.fwStartDate,
        timeZone: item.shift.timeZone,
      },
      scheduledTime: {
        startDate: item.shift.utcStartDate,
        endDate: item.shift.utcEndDate,
        timeZone: shiftDateProperties.timeZone,
        breakInMinutes: item.shift.breakMinutes,
        state: item.state,
      },
      workedTime: {
        startDate: shiftDateProperties.workTimes.startDate,
        endDate: shiftDateProperties.workTimes.endDate,
        timeZone: shiftDateProperties.timeZone,
        breakInMinutes: shiftDateProperties.workBreakInMinutes,
        state: item.state,
        timeDeviationInMs: shiftDateProperties.timeDeviationInMs,
      },
      scheduledVsWorkedDiffAndBreak: {
        deviationInMs: shiftDateProperties.timeDeviationInMs,
        breakDeviationInMs: shiftDateProperties.breakDeviationInMs,
      },
      expense: item.fwExpense,
      actions: item,
      placementEmploymentType: formatEmploymentType(placementEmploymentType),
    };
  });
  return result;
};
